import { FunctionComponent, ComponentClass } from 'react'
import { RouteProps } from 'react-router'
import { connect } from 'react-redux'
import { AppStateType } from '../../reducers'
import { selectAreaReadable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'
import { ProtectedRoute } from './ProtectedRoute'

export interface IProtectedRoute extends RouteProps {
  area: AREA_CONSTANTS
  component: FunctionComponent | ComponentClass
}

const mapStateToProps = (state: AppStateType, props: IProtectedRoute) => ({
  canViewPage: selectAreaReadable(state, props),
})

export default connect(mapStateToProps)(ProtectedRoute)
